import { FilterMenuItemType } from "types";
import styles from "./style.module.scss";
import TooltipWrapper from "views/uikit/TooltipWrapper";
import classNames from "classnames";
import { useFiltersMenu } from "../../../hooks/useFiltersMenu";

interface SingleOptionProps {
  name: string;
  icon: JSX.Element;
  disabled?: boolean;
  tooltipContent?: string;
  onSelect: () => void;
  className?: string;
}

export const SingleOption = ({
  icon,
  name,
  disabled = false,
  tooltipContent = "",
  onSelect,
  className,
}: SingleOptionProps) => {
  return (
    <div
      className={classNames(styles.filter, className, {
        [styles.disabled]: !!disabled,
      })}
      onClick={onSelect}
      data-tooltip-id={`filter-tooltip-${name}`}
      data-tooltip-content={tooltipContent}
      data-testid={`single-filter-option-${name}`}
    >
      {tooltipContent && <TooltipWrapper id={`filter-tooltip-${name}`} />}
      <div className={styles.icon}>{icon}</div>
      <span className={styles.name}>{name}</span>
    </div>
  );
};

interface FilterMenuProps {
  onSelect: (type: FilterMenuItemType) => void;
  datasetId: string;
}

export default function FilterMenu({ onSelect, datasetId }: FilterMenuProps) {
  const { activeColumnCount, filterOptions } = useFiltersMenu({
    datasetId,
    onSelect,
  });
  return (
    <div className={styles.filterMenuWrapper}>
      <div
        className={styles.filterMenu}
        data-testid="filter-menu"
        style={{
          gridTemplateColumns: `repeat(${activeColumnCount}, max-content)`,
        }}
      >
        {filterOptions.map((option, index) => {
          return (
            <SingleOption
              key={index}
              {...option}
              onSelect={option.handleSelect}
              className={option.className}
            />
          );
        })}
      </div>
    </div>
  );
}
